const OpenClass = "open";
const HiddenClass = "hidden";
export function initializeMeganavs() {
    // If you need to initialize swiper with a different look then you can add a new configuration with a different class here

    var megaNavTriggers = document.querySelectorAll("[data-mega-nav]");

    [].forEach.call(megaNavTriggers, function (megaNavTrigger) {
        initNav(megaNavTrigger);
    });

    var mobileNavs = document.querySelectorAll('[data-nav-mobile]');
    [].forEach.call(mobileNavs, function (mobileNav) {
        initMobileNav(mobileNav);
    });
}



function initNav(trigger: HTMLElement) {
    var parent = trigger.parentNode as HTMLElement;

    trigger.addEventListener("click", () => {
        if (parent.classList.contains(OpenClass)) {
            close();
        }
        else {
            open();
        }
    });


    // Close on outside click
    document.addEventListener('click', (e) => {
        if (!parent.contains(e.target as HTMLElement)) {
            close();
        }
    });

    function open() {
        if (!parent.classList.contains(OpenClass)) {
            parent.classList.add(OpenClass);
        }      
    }

    function close() {
        if (parent.classList.contains(OpenClass)) {
            parent.classList.remove(OpenClass);
        }
    }  
}

function initMobileNav(nav: HTMLElement) {
    var trigger: HTMLElement = nav.querySelector('[data-mobile-nav-trigger]');
    var panel: HTMLElement = nav.querySelector('[data-mobile-nav-panel]');
    var text: HTMLElement = nav.querySelector('[data-mobile-nav-text]');
    var body: HTMLElement = document.body;

    trigger.addEventListener('click', () => {
        toggle(trigger);
        toggle(panel);
        toggle(text);
        toggle(body);
    });

    function toggle(elem: HTMLElement) {
        if (elem.classList.contains(OpenClass)) {
            elem.classList.remove(OpenClass);
            elem.style.marginTop = null;
        }
        else {
            elem.classList.add(OpenClass);
        }
    }
}


